// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"v3-z","dimensionLabel":"w3-z","styleChooserControlWrapper":"x3-z","styleChooserControl":"y3-z","disabled":"z3-z","giftCard":"A3-z","styleChooserText":"B3-z"};